import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import SectionComponent from '../components/section.component';
import { sections } from '../../../../../../redux/sections/action';
import { selectSectionsQueryItems } from '../../../../../../redux/sections/selector';


const ManagementSection = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const sectionQuery = useSelector(selectSectionsQueryItems)
    const [
        selectedSections,
        setSelectedSections
    ] = useState<any>([])

    const fetchSectionsQueryById = () => {
        dispatch(sections.query({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/contract/sections/query`, entity: 'sections', jsonData: {

                Records: [
                    {
                        "Id": parmas?.id
                    }
                ]

            }
        })).then(() => {
            setIsQuery(true)
        }).then(() => {
            setIsLoading(false)
        })




    }

    const handleInnerbasicFormChange: any = (event: any, field: string) => {
        setSelectedSections({ ...selectedSections, [field]: event })
    }



    useEffect(
        () => {
            if (parmas?.id > 0) {
                fetchSectionsQueryById()
                setIsLoading(false)
            } else {
                setIsLoading(false)
            }
        },
        []
    )
    useEffect(
        () => {

            if (isQuery) {
                setSelectedSections(sectionQuery?.result?.items)

            }
        },
        [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();

        if (parmas?.id > 0) {
            dispatch(sections.update({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/contract/sections`, entity: 'sections', jsonData: {

                    Records: [
                        selectedSections

                    ]

                }
            })).then(() => {
                back()
            })

        } else {
            dispatch(sections.create({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/contract/sections`, entity: 'sections', jsonData: {

                    Records: [
                        selectedSections
                    ]

                }
            })).then(() => {
                back()
            })
        }

    }

    const back = () => {
        navigate('/management/e-applications/contract/sections')
    }


    return (
        <>
            {isLoading ? <PageLoader /> :
                <SectionComponent
                    selectedSections={selectedSections}
                    onInnerBasicFormChange={handleInnerbasicFormChange}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                />
            }

        </>
    )

}

export default ManagementSection;